var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.componentView),function(com){return _c('dynamic-components',{attrs:{"props":com,"formData":_vm.data},on:{"callfunction":_vm.handle_function_call}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }